// The household page state (none, owner, member, inactive) is read under this key.
export const HOUSEHOLD_QUERY_KEY = ['households', 'me'] as const;
export const HOUSEHOLD_ACCOUNTS_KEY = ['households', 'me', 'accounts'] as const;
export const HOUSEHOLD_SUMMARY_KEY = ['households', 'me', 'summary'] as const;
export const HOUSEHOLD_CATEGORIES_KEY = ['households', 'me', 'categories'] as const;
// Totals group movements by category links, so a link change or an edit moves money between rows.
export const HOUSEHOLD_TOTALS_KEY = ['households', 'me', 'category-totals'] as const;
